import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export const GROUP = { id: "GROUP", name: "Group Consolidated", code: "GRP" };

export function SiteProvider({ children }) {
  const { user } = useAuth();
  const [sites, setSites] = useState([]);
  const [activeSite, setActiveSite] = useState("GROUP");

  useEffect(() => {
    if (user && user !== false) {
      api.get("/sites").then((r) => setSites(r.data)).catch(() => {});
    }
  }, [user]);

  const allSites = [GROUP, ...sites];
  const current = allSites.find((s) => s.id === activeSite) || GROUP;

  return (
    <SiteContext.Provider value={{ sites, allSites, activeSite, setActiveSite, current }}>
      {children}
    </SiteContext.Provider>
  );
}
